import { render } from "./DashboardPages.vue?vue&type=template&id=1b814048"
import script from "./DashboardPages.vue?vue&type=script&lang=js"
export * from "./DashboardPages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__